import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../hooks/useAuth';

const GuestGuard = ({ children }) => {
  const { isAuthenticated, badgedIn } = useAuth();

  if (isAuthenticated && badgedIn) {
    return <Redirect to="/app/processes" />;
  } else if (isAuthenticated && !badgedIn) {
    return <Redirect to="/badgescan" />;
  } else

  return (
    <>
      {children}
    </>
  );
};

GuestGuard.propTypes = {
  children: PropTypes.node
};

export default GuestGuard;
